// Modules
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

// Hooks
import useNotices from 'hooks/system/useNotices'

// Helpers
// import { checkIfConvertibleToURL } from 'helpers/format'
import { requestSSOToken } from 'helpers/network'

// Data (Local)
// const redirectURLHosts = ['dev-label.aixplain.com', 'localhost:4200', 'api-vision.apptek.com']

// Hook: External > Single sign on
function useSingleSignOn ({ redirectURL, willSkip }) {
	// Data
	const { addNotice } = useNotices()
	// const [searchParameters, setSearchParameters] = useSearchParams()

	// State
	// const [redirectURL, setRedirectURL] = useState(null)

	// Effects
	/*
	useEffect(() => {
		const redirectURLParameter = searchParameters.get('redirect_url')
		if (!!redirectURLParameter && checkIfConvertibleToURL(redirectURLParameter)) {
			searchParameters.delete('redirect_url')
			setSearchParameters(searchParameters, { replace: true })
			// const { hostname } = new URL(redirectURL)
			// if (redirectURLHosts.includes(hostname)) setRedirectURL(redirectURL)
			const redirectionURL = new URL(redirectURLParameter)
			if (redirectionURL.hostname.endsWith('aixplain.com') || redirectURLHosts.includes(redirectionURL.hostname)) {
				setRedirectURL(redirectURLParameter)
			}
		}
	}, [searchParameters, setSearchParameters])
	*/
	useEffect(() => {
		if (!!redirectURL && !willSkip) {
			async function redirect () {
				const redirectionURL = new URL(redirectURL)
				// if (redirectURLHosts.includes(redirectionURL.hostname)) {
					const { data, error } = await requestSSOToken()
					if (!!error) addNotice({ code: error, log: error, type: 'error' })
					else if (!!data) {
						redirectionURL.searchParams.append('token', data.token)
						window.location.href = redirectionURL.href
					}
				// }
			}
			redirect()
		}
	}, [addNotice, redirectURL, willSkip])

	// Response
	// return { willRedirect: !!redirectURL }
}

// Export
export default useSingleSignOn
